// src/redux/driverLicenseApi.js
import { apiSlice } from "./apiSlice";

export const driverLicenseApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        verifyDriverLicense: build.mutation({
            query: ({ name, license_number, license_type, contract_driver_id }) => ({
                url: `/api/user/driver_license/v1/verification`,
                method: "get",
                headers: { token: true },
                params: { name, license_number, license_type, contract_driver_id },
            }),
        }),
    }),
});

export const { useVerifyDriverLicenseMutation } = driverLicenseApi;
